import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Paper, TextField, Button, Grid } from '@mui/material';

const EspacoRecepcao = () => {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ local: '', valor_decoracao: '', data_agendada: '', valor_locacao: '', endereco: '' });
  const [editId, setEditId] = useState(null);

  const fetchData = async () => {
    const res = await axios.get('/api/espaco_recepcao');
    setDados(res.data);
  };

  useEffect(() => { fetchData(); }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (editId) {
      await axios.put(`/api/espaco_recepcao/${editId}`, form);
    } else {
      await axios.post('/api/espaco_recepcao', form);
    }
    setForm({ local: '', valor_decoracao: '', data_agendada: '', valor_locacao: '', endereco: '' });
    setEditId(null);
    fetchData();
  };

  const handleEdit = item => {
    setForm(item);
    setEditId(item.id);
  };

  const handleDelete = async id => {
    await axios.delete(`/api/espaco_recepcao/${id}`);
    fetchData();
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Espaço Recepção</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="Local" name="local" value={form.local} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Valor Decoração" name="valor_decoracao" value={form.valor_decoracao} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Valor Locação" name="valor_locacao" value={form.valor_locacao} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Data Agendada" name="data_agendada" value={form.data_agendada} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Endereço" name="endereco" value={form.endereco} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={12}><Button type="submit" variant="contained">{editId ? 'Salvar' : 'Adicionar'}</Button></Grid>
          </Grid>
        </form>
      </Paper>
      {dados.map(item => (
        <Paper key={item.id} sx={{ p: 2, mb: 1 }}>
          <Typography><b>Local:</b> {item.local}</Typography>
          <Typography><b>Decoração:</b> R$ {item.valor_decoracao}</Typography>
          <Typography><b>Locação:</b> R$ {item.valor_locacao}</Typography>
          <Typography><b>Data:</b> {item.data_agendada}</Typography>
          <Typography><b>Endereço:</b> {item.endereco}</Typography>
          <Button onClick={() => handleEdit(item)} sx={{ mr: 1 }}>Editar</Button>
          <Button color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
        </Paper>
      ))}
    </Container>
  );
};

export default EspacoRecepcao;
